// Third party import
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ActionState {
  callGetActions: boolean;
  callGetInitiative: boolean;
}

const initialState: ActionState = {
  callGetActions: false,
  callGetInitiative: false};

export const reviewSlice = createSlice({
  name: "action",
  initialState,
  reducers: {
    setCallGetActions: (
      state: { callGetActions: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callGetActions = action.payload;
    },
    setCallGetInitiative: (
      state: { callGetInitiative: boolean },
      action: PayloadAction<boolean>
    ) => {
      state.callGetInitiative = action.payload;
    }}});

export const { setCallGetActions, setCallGetInitiative } = reviewSlice.actions;

export default reviewSlice.reducer;
